import React, { useState, useEffect } from 'react'
import PropTypes from 'prop-types'
import { Pagination, Tooltip, Checkbox, Modal, message, Input } from 'antd'
import {
  TitleContainer,
  Title,
  TableActions,
  Button,
  TableWrapper,
  HeaderWrapper,
  TableTitleLeft,
  PaginationWrapper,
  Paragraph,
  InfoRowWrapper,
  InfoRow,
  InfoRowIcons,
  Separator,
  EditIcon,
  DeleteIcon,
  TitleBox
} from '../../styles'
import Search from 'antd/lib/input/Search'
import { LoadingSpin } from '../../../LoadingSpin'
import { Text } from '../../../../constants/TextConstants'
import { parseItemMessage, arrowOrder, cleanString, searchCaseInsensitive } from '../../../../utils/utils'
import { epagAPI } from '../../../../API/epagAPI'
import { useInputValue } from '../../../../hooks/useInputValue'
import { useGetToken } from '../../../../hooks/useGetToken'
import { Spinner } from '../../../Spinner'

export const ListManagementTable = ({
  title,
  isLoadingLists,
  lists,
  totalItems,
  listSorted,
  setListsorted,
  handleSearch,
  skillName,
  skillType,
  updateList
}) => {
  const openModalInitialState = {
    create: false,
    edit: false,
    delete: false,
    deleteAll: false
  }

  // label text replacement factory
  const textLabels = useTextLabels({ title, skillName })

  const [itemsToDelete, setItemsToDelete] = useState([])
  const [itemsPerPage, setItemsPerPage] = useState(10)
  const [actualPage, setActualPage] = useState(1)
  const [order, setOrder] = useState(1)
  const [openModal, setOpenModal] = useState(openModalInitialState)
  const [showSppiner, setShowSppiner] = useState(false)
  const [itemName, setItemName] = useState()
  const [newLanguageName, setNewLanguageName] = useState('')
  const inputName = useInputValue('')
  const inputNewName = useInputValue('')
  const { token } = useGetToken()

  const onShowSizeChange = (_, pageSize) => {
    setItemsPerPage(pageSize)
  }

  const onChangePagination = (current) => {
    setActualPage(current)
  }

  const clearInputs = () => {
    inputName.setValue('')
    inputNewName.setValue('')
    setNewLanguageName('')
  }

  const onClickCreate = () => {
    setOpenModal({ ...openModal, create: true })
  }

  const onClickEdit = (item) => {
    setOpenModal({ ...openModal, edit: true })
    setItemName(item)
    inputName.setValue(item)
  }

  const onClickDelete = (item) => {
    setOpenModal({ ...openModal, delete: true })
    setItemName(item)
  }

  const onClickDeleteAll = () => {
    setOpenModal({ ...openModal, deleteAll: true })
    setItemName(itemsToDelete.join(', '))
  }

  const onCancelModal = () => {
    setShowSppiner(false)
    setOpenModal(openModalInitialState)
    clearInputs()
  }

  const onChangeNewName = (e) => {
    inputNewName.onChange(e)
    setNewLanguageName(e.target.value)
  }

  const onChangeName = (e) => {
    inputName.onChange(e)
    setNewLanguageName(e.target.value)
  }

  const createItem = () => {
    if (!newLanguageName || newLanguageName.trim() === '') {
      message.warning(textLabels.ListManagmentItemCreatedIsEmptyWarning, 3)
      return
    }
    if (!searchCaseInsensitive(listSorted, newLanguageName)) {
      setShowSppiner(true)
      epagAPI
        .CreateSkill(skillType, newLanguageName.trim(), token)
        .then((response) => {
          if (response.nModified > 0) {
            message.success(textLabels.ListManagmentItemCreated, 3)
            updateList()
          } else {
            message.warning(textLabels.ListManagmentItemNotCreated, 3)
          }
          setOpenModal({ ...openModal, create: false })
        })
        .catch((error) => {
          console.error(error)
          message.error(textLabels.ListManagmentItemCreationError, 3)
        })
        .finally(() => {
          setShowSppiner(false)
          clearInputs()
        })
    } else {
      message.warning(textLabels.ListManagmentItemCreatedIsEqualWarning, 3)
    }
  }

  const editLevel = () => {
    if (
      searchCaseInsensitive(listSorted, newLanguageName) ||
      !newLanguageName ||
      cleanString(itemName) === cleanString(newLanguageName)
    ) {
      message.warning(textLabels.ListManagmentItemIsEqualWarning, 3)
      return
    }
    setShowSppiner(true)
    epagAPI
      .UpdateSkills(skillType, itemName, newLanguageName.trim(), token)
      .then((response) => {
        if (response) {
          message.success(textLabels.ListManagmentItemEdited, 3)
          updateList()
        } else {
          message.warning(textLabels.ListManagmentItemNotEdited, 3)
        }
        setOpenModal({ ...openModal, edit: false })
      })
      .catch((error) => {
        console.error(error)
        message.error(textLabels.ListManagmentItemEditionError, 3)
      })
      .finally(() => {
        setShowSppiner(false)
        clearInputs()
      })
  }
  const deleteItem = () => {
    setShowSppiner(true)
    epagAPI
      .DeleteSkill(skillType, itemName, token)
      .then((response) => {
        if (response) {
          message.success(textLabels.ListManagmentItemDelete, 3)
          updateList()
        } else {
          message.warning(textLabels.ListManagmentItemDeleteError, 3)
        }
        setOpenModal({ ...openModal, delete: false })
      })
      .catch((error) => {
        console.error(error)
        message.error(textLabels.ListManagmentItemDeleteError, 3)
      })
      .finally(() => {
        setItemsToDelete([])
        setShowSppiner(false)
        clearInputs()
      })
  }

  const DeleteVariousItems = () => {
    setShowSppiner(true)
    epagAPI
      .DeleteSkill(skillType, itemsToDelete, token)
      .then((response) => {
        if (response) {
          message.success(textLabels.ListManagmentItemDeleteVarious, 3)
          updateList()
        } else {
          message.warning(textLabels.ListManagmentItemNotDeleteVarious, 3)
        }
        setOpenModal({ ...openModal, deleteAll: false })
      })
      .catch((error) => {
        console.error(error)
        message.error(textLabels.ListManagmentItemDeleteVariousError, 3)
      })
      .finally(() => {
        setItemsToDelete([])
        setShowSppiner(false)
        clearInputs()
      })
  }

  const manageSearch = (value) => {
    setActualPage(1)
    handleSearch(value)
  }

  const ListsGenerated = () => {
    const handleCheckboxChange = (item) => {
      if (itemsToDelete.includes(item)) {
        setItemsToDelete((prevSelectedItems) => prevSelectedItems.filter((selectedItem) => selectedItem !== item))
      } else {
        setItemsToDelete((prevSelectedItems) => [...prevSelectedItems, item])
      }
    }

    if (!lists.length) {
      return <Paragraph>{Text.NoResults}</Paragraph>
    }

    return listSorted.map((item, Index) => {
      if (itemsPerPage * (actualPage - 1) <= Index && Index < itemsPerPage * actualPage) {
        return (
          <InfoRowWrapper key={Index}>
            <div style={{ width: '5%', display: 'flex', justifyContent: 'center' }}>
              <Checkbox checked={itemsToDelete.includes(item)} onChange={() => handleCheckboxChange(item)} />
            </div>
            <InfoRow $align='left' $width='65%'>
              {item}
            </InfoRow>
            <InfoRowIcons $align='center' $width='30%'>
              <Tooltip title={itemsToDelete.includes(item) ? 'Unselect this element in order to edit' : `Edit ${item}`}>
                <Separator />
                <EditIcon
                  aria-label='edit-item-icon'
                  style={itemsToDelete.includes(item) ? { cursor: 'not-allowed' } : { cursor: 'pointer' }}
                  size='22'
                  onClick={!itemsToDelete.includes(item) ? () => onClickEdit(item) : () => {}}
                  disabled={itemsToDelete.includes(item)}
                />
              </Tooltip>
              <Separator />
              <Tooltip title={`Delete ${item}`}>
                <DeleteIcon
                  aria-label='delete-item-icon'
                  style={{ cursor: 'pointer' }}
                  size='22'
                  onClick={() => onClickDelete(item)}
                />
              </Tooltip>
            </InfoRowIcons>
          </InfoRowWrapper>
        )
      }
    })
  }

  return (
    <>
      <TitleContainer>
        <Title>{title}</Title>
        <TableActions>
          <Search placeholder={`Filter ${Text.Levels}`} allowClear onSearch={manageSearch} style={{ width: 200 }} />
          {itemsToDelete.length > 0 && (
            <Button danger onClick={onClickDeleteAll}>
              Delete ({itemsToDelete.length})
            </Button>
          )}
          <Button type='primary' onClick={onClickCreate}>
            + New
          </Button>
        </TableActions>
      </TitleContainer>
      <TableWrapper>
        {!isLoadingLists && (
          <HeaderWrapper>
            <div style={{ width: '5%' }} />
            <TableTitleLeft $width='65%'>
              {Text.Name} {arrowOrder(order, setOrder, 'name', setListsorted, lists)}
            </TableTitleLeft>
            <TableTitleLeft $width='30%'>{Text.Actions}</TableTitleLeft>
          </HeaderWrapper>
        )}
        {isLoadingLists ? <LoadingSpin /> : <ListsGenerated />}
      </TableWrapper>
      {!isLoadingLists && (
        <PaginationWrapper>
          <Pagination
            showSizeChanger
            onShowSizeChange={onShowSizeChange}
            current={actualPage}
            total={totalItems}
            defaultPageSize={itemsPerPage}
            onChange={(actualPage, pageSize) => onChangePagination(actualPage, pageSize)}
          />
        </PaginationWrapper>
      )}
      {/* create modal */}
      <Modal
        title={textLabels.CreateItemMessage}
        open={openModal.create}
        width='350px'
        okText={'Create'}
        onOk={createItem}
        onCancel={onCancelModal}
        maskClosable={false}
        keyboard={false}>
        {showSppiner ? (
          <Spinner top='10px' />
        ) : (
          <section>
            <article style={{ marginTop: '1px' }}>
              <TitleBox style={{ marginLeft: '4px' }}>
                <label htmlFor='name'>Name:</label>
              </TitleBox>
              <Input
                name='name'
                id='name'
                data-testid='new-level-name'
                placeholder='Enter the Name'
                style={{ margin: '4px' }}
                onChange={onChangeNewName}
                value={inputNewName.value}
              />
            </article>
          </section>
        )}
      </Modal>
      {/* edit modal */}
      <Modal
        title={textLabels.EditItemMessage}
        open={openModal.edit}
        width='350px'
        okText={'Save'}
        onOk={editLevel}
        onCancel={onCancelModal}
        maskClosable={false}
        keyboard={false}>
        {showSppiner ? (
          <Spinner top='10px' />
        ) : (
          <section>
            <article style={{ marginTop: '1px' }}>
              <TitleBox style={{ marginLeft: '4px' }}>Name:</TitleBox>
              <Input
                name='skill-name'
                data-testid='level-name'
                placeholder='Enter the Name'
                style={{ margin: '4px' }}
                onChange={onChangeName}
                value={inputName.value}
              />
            </article>
          </section>
        )}
      </Modal>
      {/* delete modal */}
      <Modal
        title={textLabels.DeleteItemMessage}
        open={openModal.delete}
        width='350px'
        okText={'Delete'}
        onOk={deleteItem}
        onCancel={onCancelModal}
        maskClosable={false}
        keyboard={false}>
        {parseItemMessage(Text.DeleteConfirmItemMessage, itemName)}
        {showSppiner ? <Spinner top='10px' /> : null}
      </Modal>
      {/* delete all modal */}
      <Modal
        title={textLabels.DeleteVariousItemsMessage}
        open={openModal.deleteAll}
        width='350px'
        okText={'Delete'}
        onOk={DeleteVariousItems}
        onCancel={onCancelModal}
        maskClosable={false}
        keyboard={false}>
        {parseItemMessage(Text.DeleteConfirmItemMessage, itemsToDelete.join(', '))}
        {showSppiner ? <Spinner top='10px' /> : null}
      </Modal>
    </>
  )
}

const useTextLabels = function ({ title, skillName }) {
  // @title will be for messages in plural
  // @skillName will be for messages in singular
  const [textLabels, setTextLabels] = useState({})
  useEffect(() => {
    if (skillName && title) {
      setTextLabels(textLabelsFactory(Text, { singularSkillName: skillName, pluralSkillName: title }))
    }
  }, [title, skillName])
  return textLabels
}

function textLabelsFactory(
  {
    ListManagmentItemCreatedIsEqualWarning,
    ListManagmentItemCreatedIsEmptyWarning,
    ListManagmentItemIsEqualWarning,
    ListManagmentItemCreated,
    ListManagmentItemNotCreated,
    ListManagmentItemCreationError,
    ListManagmentItemEdited,
    ListManagmentItemNotEdited,
    ListManagmentItemEditionError,
    ListManagmentItemDelete,
    ListManagmentItemNotDelete,
    ListManagmentItemDeleteError,
    ListManagmentItemDeleteVarious,
    ListManagmentItemNotDeleteVarious,
    ListManagmentItemDeleteVariousError,
    DeleteItemMessage,
    EditItemMessage,
    CreateItemMessage
  },
  { singularSkillName, pluralSkillName }
) {
  const singularSkillnameLowercase = singularSkillName.toLowerCase()
  const pluralSkillnameLowercase = pluralSkillName.toLowerCase()

  return {
    ListManagmentItemCreatedIsEqualWarning: parseItemMessage(ListManagmentItemCreatedIsEqualWarning, singularSkillName),
    ListManagmentItemCreatedIsEmptyWarning: parseItemMessage(ListManagmentItemCreatedIsEmptyWarning, singularSkillName),
    ListManagmentItemIsEqualWarning: parseItemMessage(ListManagmentItemIsEqualWarning, singularSkillName),
    ListManagmentItemCreated: parseItemMessage(ListManagmentItemCreated, singularSkillName),
    ListManagmentItemNotCreated: parseItemMessage(ListManagmentItemNotCreated, singularSkillName),
    ListManagmentItemCreationError: parseItemMessage(ListManagmentItemCreationError, singularSkillnameLowercase),
    ListManagmentItemEdited: parseItemMessage(ListManagmentItemEdited, singularSkillName),
    ListManagmentItemNotEdited: parseItemMessage(ListManagmentItemNotEdited, singularSkillName),
    ListManagmentItemEditionError: parseItemMessage(ListManagmentItemEditionError, singularSkillnameLowercase),
    ListManagmentItemDelete: parseItemMessage(ListManagmentItemDelete, singularSkillName),
    ListManagmentItemNotDelete: parseItemMessage(ListManagmentItemNotDelete, singularSkillName),
    ListManagmentItemDeleteError: parseItemMessage(ListManagmentItemDeleteError, singularSkillnameLowercase),
    ListManagmentItemDeleteVarious: parseItemMessage(ListManagmentItemDeleteVarious, pluralSkillName),
    ListManagmentItemNotDeleteVarious: parseItemMessage(ListManagmentItemNotDeleteVarious, pluralSkillName),
    ListManagmentItemDeleteVariousError: parseItemMessage(
      ListManagmentItemDeleteVariousError,
      pluralSkillnameLowercase
    ),
    DeleteItemMessage: parseItemMessage(DeleteItemMessage, singularSkillnameLowercase),
    EditItemMessage: parseItemMessage(EditItemMessage, singularSkillnameLowercase),
    CreateItemMessage: parseItemMessage(CreateItemMessage, singularSkillnameLowercase)
  }
}

ListManagementTable.propTypes = {
  title: PropTypes.string.isRequired, // will be used as plural string for the messaging
  isLoadingLists: PropTypes.bool,
  lists: PropTypes.array,
  listSorted: PropTypes.array,
  totalItems: PropTypes.number,
  handleSearch: PropTypes.func,
  handleEdit: PropTypes.func,
  handleDelete: PropTypes.func,
  skillName: PropTypes.string.isRequired, // will be used as singular string for messaging
  skillType: PropTypes.string,
  updateList: PropTypes.func,
  setListsorted: PropTypes.func
}
